import React, { Component } from 'react'
import styled from 'styled-components'
import { submitContactForm } from '../services/actions'
import FormGroup from 'components/FormGroup'
import Input from 'components/Input'
import TextArea from 'components/TextArea'
import PropTypes from 'prop-types'
import { Flex, Text } from 'rebass/styled-components'
import Button from 'components/Button'

 
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const validate = (state) => {
  const { email, name, message } = state
  if (!email || !name || !message) {
    return false
  }
  return EMAIL_REGEX.test(email) && name.length > 2 && message.length > 2
}

const FixedTextArea = styled(TextArea)`
  resize: none;
`

const SubmitButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  width: 100%;
  height: 100%;
  letter-spacing: ${(props) => props.theme.letterSpacing};
  text-transform: uppercase;
  border-radius: 0;
  font-size: ${(props) => props.theme.fontSizes[5]}px;
  padding: ${(props) => props.theme.space[2]}px;
  cursor: pointer;
  &:disabled {
    transition: background-color 0.2s ease;
    background-color: ${(props) => props.theme.colors.grey2};
  }
`

class ContactForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      form: false, // disabling form for now
      email: '',
      name: '',
      message: '',
      response: '',
    }
  }

  componentDidMount () {
    const { message } = this.props  
    if (message) {
      this.setState({ response: message })
    } else {
      this.setState({
        response:
          "Connect with us at hi@fountstudio.com. We'd love to see where we can collaborate.",
      })
    }
  }

  handleForm = (e) => {
    e.preventDefault()
    const { email, name, message } = this.state
    const data = {
      email,
      name,
      message,
    }
    const _this = this
    submitContactForm(data)
      .then(() => {
        _this.setState({
          form: false,
          email: '',
          name: '',
          message: '',
          response: `Thanks! We’ll reply shortly. Feel free to send us more details at hi@fountstudio.com`,
        })
      })
      .then(() => {
        if (window.gtag) {
          window.gtag('event', 'submit_contact_form', {
            event_category: 'engagement',
            event_label: data.email,
          })
        }
      })
      .catch((err) => {
        //console.log(err)
        this.setState({ response: `${err.message}. Bummer. Please try again.` })
      })
  }

  update = (key, val) => {
    this.setState({
      [key]: val,
    })
  }

  render () {
    const validForm = validate(this.state)
    const { response, form } = this.state
    const { message = ''} = this.props
    return (
      <Flex flexDirection='column'>
        <Text mt={4} mb={2} fontSize={4} textAlign='center' color='gray1'>
          {response}
        </Text>
        {form && (
          <Flex flexWrap='wrap' is='form' my={3} mx={-2} width={[1]}>
            <Text textAlign='center' my={2} fontSize={2} color='primary'>
              For support on our products, please visit their support pages{' '}
              <a
                href='https://export.fountstudio.com/web/support'
                target='_blank'
                rel='noopener noreferrer'
              >
                Export
              </a>
              ,
              <a
                href='https://vote.fountstudio.com/web/support'
                target='_blank'
                rel='noopener noreferrer'
              >
                Vote
              </a>
              {', and '}
              <a
                href='https://spoiler.fountstudio.com/support'
                target='_blank'
                rel='noopener noreferrer'
              >
                Spoiler
              </a>
              .
            </Text>
            <FormGroup width={[1, 1, 1, 1 / 2]} mb={3} px={2}>
              <Input
                placeholder='Name'
                type='text'
                onChange={(e) => this.update('name', e.target.value)}
              />
            </FormGroup>
            <FormGroup width={[1, 1, 1, 1 / 2]} mb={3} px={2}>
              <Input
                placeholder='Email'
                type='email'
                onChange={(e) => this.update('email', e.target.value)}
              />
            </FormGroup>
            <FormGroup width={1} mb={3} px={2}>
              <FixedTextArea
                placeholder='Share a few words about your opportunity...'
                rows={6}
                onChange={(e) => this.update('message', e.target.value)}
              />
            </FormGroup>
            <FormGroup width={1} px={2}>
              <SubmitButton disabled={!validForm} onClick={this.handleForm}>
                Send
              </SubmitButton>
            </FormGroup>
          </Flex>
        )}
      </Flex>
    )
  }
}

ContactForm.propTypes = {
  message: PropTypes.string,
}

export default ContactForm
